const architects = [
  {
    id: 'A1',
    url: 'zaborsky',
    name: 'Zaborsky Georgiy Vladimirovich',
    bornDate: '11/11/1909',
    born: 'November 11, 1909',
    deceased: 'April 27, 1999',
    description: 'National Architect of the USSR (1981), Honored Builder of Belarus, Academician of the Russian Academy of Architecture and Construction Sciences, Academician of the Belarusian Academy of Architecture, winner of the USSR State Prize (1971).',
    image: 'http://bsa.by/ckfinder/userfiles/images/4(2).jpg',
    placeOfResidence: 'Minsk',
    placeOfBirth: 'Minsk',
    bio: [
      {date: '1909', text: 'Georgy Zaborsky was born in Minsk to the family of Vladimir Georgievich Zaborsky, an accountant of the Moscow-Brest Railway, and Elena Ivanovna Zaborskaya (Zegling).'},
      {date: '1930', text: 'Entered the Minsk Vocational School of peasant refractory construction. The first practice of G. Zaborsky was held at the construction site of the Government House. Here he met with the architect I. Langbard.'},
      {date: '1939', text: 'He graduated from the Academy of Arts. He entered the contest in Moscow, but he worked there for a short time and quickly received a referral to Minsk. Here he was appointed head of a scientific expedition to study the monuments of architecture and art of the Gomel and Polesye regions.'},
      {date: '1941-1945', text: 'He went to the front as a volunteer, but in the battles near Smolensk he was seriously wounded and ended up in the hospital of the Ural town of Troitsk, where he completed a number of projects-sketches of monuments dedicated to the heroic victory of the Soviet people in the Great Patriotic War.'},
      {date: '1945-1964', text: 'Georgiy Zaborsky headed the architectural design workshops of design institutes Belgosproek and Minskproekt and at the same time teached at the architectural department of the Belarusian Polytechnic Institute (now the Belarusian National Technical University).'},
      {date: '1993', text: 'He finished his activities. One of his last work was the project of a monument to victims of mass repressions in Kurapaty near Minsk.'},
    ],
    project: [
      {date: '1952', text: 'Designed a house for the family of J. Kolas.'},
      {date: '1954', text: 'Monument monument on Victory square.'},
      {date: '1962', text: 'According to the designs of the architect, the Pioneer cinema and the Museum of the Great Patriotic War were built.'},
      {date: '1969', text: 'The memorial complex \'Zislov\' was opened.'},
    ],
    video: {
      id: 'lxMfVdAml1A'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://naviny.by/media/2015.09_w1/yacub.jpg',
        width: 4,
        height: 3,
        title: 'Monument to Y. Kolos',
        text: 'Monument to Y. Kolos.'
      },
      {
        num: 2,
        src: 'https://minsknews.by/wp-content/uploads/2018/05/APD_8846-1.jpg',
        width: 2,
        height: 2,
        title: 'Monument at Victory Square',
        text: 'Monument at Victory Square.'
      },
      {
        num: 3,
        src: 'https://minsk-old-new.com/assets/images/Image/streets/krasnoarmeyskaya/krasnoarmeyskaya-024.jpg',
        width: 2,
        height: 2,
        title: 'The building of the Central Committee of LKSMB',
        text: 'The building of the Central Committee of LKSMB.'
      },
      {
        num: 4,
        src: 'https://planetabelarus.by/upload/resize_cache/iblock/901/1330_887_18e21fe612b4afb807a26ecc22279a1d9/901c0376763ffee6a3fb245ea62fba25.jpg',
        width: 4,
        height: 3,
        title: 'Minsk Suvorov Military School',
        text: 'Minsk Suvorov Military School.'
      },
    ],
  },

  {
    id: 'A2',
    url: 'usova',
    name: 'Lyubov Usova',
    bornDate: '9/6/1921',
    born: '6 September 1921',
    deceased: 'Present',
    description: 'Lyubov Usova - a person known in architectural circles. First of all, she known as one of the developers of the new post-war general plan of the Minsk city. With her direct participation there were erected a lot of significant objects. For her creative work she was repeatedly awarded with the certificates of the Supreme Council of the BSSR, certificates of honor and certificates of the Minsk Project Institute, as well as the Unions of Architects of the USSR and the BSSR. She was inducted into the Minsk Project Institute\'s Book of Honor.',
    image: 'https://minsknews.by/wp-content/uploads/2014/10/Arhitektor-Usova-3.jpg',
    placeOfResidence: 'Minsk, Belarus',
    placeOfBirth: 'Irkutsk, Russia',
    bio: [
      {date: '1921', text: 'Was born in Irkutsk.'},
      {date: '1930', text: 'When she was nine, her family moved to Moscow where she attended high school and then entered the Moscow Institute of Architecture.'},
      {date: '1941-1945', text: 'During the Great Patriotic War was evacuated in Tashkent.'},
      {date: '1947', text: 'She graduated with honors in 1947 with a degree in architecture and soon moved to Minsk, where her husband was working.'},
      {date: '1989', text: 'Was inducted into the Minsk Project Institute\'s Book of Honor['},
    ],
    project: [
      {date: '1950', text: 'Designed and restored the main building of BPI (BNTU).'},
      {date: '1952', text: 'Designed the Palace of Pioneers and schoolchildren.'},
      {date: '1954', text: 'Designed the PBC regional committee building.'},
      {date: '1956', text: 'Designed the Belorussian Republican Youth Theater.'},
      {date: '1960-1970', text: 'Reconstructed some of the schools and kindergartens, designed residential buildings together with her husband in the area near Real station Square, residential quarters of some factories. She took part in the creation of a public garden near the Opera and Ballet Theater and the Victory Park, was engaged in the reconstruction of the Gorky Children\'s Park as well.'},
      {date: '1968', text: 'Designed the republican palace of the young technicians.'},
      {date: '1970-1980', text: 'She did the architectural planning work of the Minsk water cascade - the Drozdy and Krynytsya reservoirs.'},
    ],
    video: {
      id: 'FCQd9J67N0o'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'http://arcp.by/sites/arcp.by/files/styles/660/public/articlefoto/rsg-13-2014_final_stranica_5_izobrazhenie_0002.jpg',
        width: 4,
        height: 3,
        title: 'Lyubov Usova',
        text: 'Lyubov Usova (on the right) with colleagues at work on the project of the cinema \'Star\'.'
      },
      {
        num: 2,
        src: 'http://arcp.by/sites/arcp.by/files/styles/660/public/articlefoto/rsg-13-2014_final_stranica_5_izobrazhenie_0004.jpg',
        width: 2,
        height: 2 ,
        title: 'With the husband',
        text: 'Lyubov Usova with her husband Vasily Gerashchenko.'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Minsk_CIS_executive_committee.JPG/800px-Minsk_CIS_executive_committee.JPG',
        width: 2,
        height: 2,
        title: 'Building of the regional security committee',
        text: 'Building of the regional security committee'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Belarus-Minsk-Railway_Station_Square-4.jpg/800px-Belarus-Minsk-Railway_Station_Square-4.jpg',
        width: 2,
        height: 2,
        title: 'Railway Station Square, Minsk',
        text: 'Gate at Railway Station Square.'
      },
      {
        num: 5,
        src: 'https://farm4.static.flickr.com/3286/2958042964_43082c0ef6_o.jpg',
        width: 4,
        height: 3,
        title: 'Republican Palace of Pioneers and Schoolchildren',
        text: 'Republican Palace of Pioneers and Schoolchildren.'
      },
      {
        num: 6,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Enhie%C4%BAsa_Street_26.jpg/1024px-Enhie%C4%BAsa_Street_26.jpg',
        width: 2,
        height: 2,
        title: 'Theater of the young spectator',
        text: 'Belorussian State Academic Theater of the Young Spectator.'
      },
      {
        num: 7,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/BNTU.JPG',
        width: 4,
        height: 3,
        title: 'Belorussian Polytechnic Institute.',
        text: 'Belorussian Polytechnic Institute.'
      },
      {
        num: 8,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Alleya_of_Opera_and_Ballet_Theatre%2C_Minsk.JPG/1024px-Alleya_of_Opera_and_Ballet_Theatre%2C_Minsk.JPG',
        width: 2,
        height: 2,
        title: 'Park at the The National Academic Grand Opera and Ballet Theatre',
        text: 'Park at the The National Academic Grand Opera and Ballet Theatre of the Republic of Belarus'
      },
      {
        num: 9,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BD%D0%B8%D0%BA_%D0%97%D0%B0%D1%85%D0%B0%D1%80%D0%B8%D1%8E_%D0%9A%D0%BE%D1%80%D0%BD%D0%B5%D0%B5%D0%B2%D1%83%2C_Minsk%2C_Belarus_-_panoramio_%281%29.jpg/1280px-%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BD%D0%B8%D0%BA_%D0%97%D0%B0%D1%85%D0%B0%D1%80%D0%B8%D1%8E_%D0%9A%D0%BE%D1%80%D0%BD%D0%B5%D0%B5%D0%B2%D1%83%2C_Minsk%2C_Belarus_-_panoramio_%281%29.jpg',
        width: 2,
        height: 2,
        title: 'Maksim Gorky Central Children\'s Park',
        text: 'Maksim Gorky Central Children\'s Park. Bridge over the embankment of Svisloch river'
      },
    ],
  },

  {
    id: 'A3',
    url: 'parusnikov',
    name: 'Mikhail Pavlovich Parusnikov',
    bornDate: '11/12/1893',
    born: 'November 12, 1893',
    deceased: 'February 2, 1968',
    description: 'Soviet architect, full member of the Academy of Architecture of the USSR (1950), academician of the BSSR (1950; corresponding member since 1947). Teacher, Professor (since 1948). Laureate of the State prize of the Belarusian SSR (1968).',
    image: 'http://cn.flibusta.site/i/89/452389/img_84.jpg',
    placeOfResidence: 'Moscow',
    placeOfBirth: 'Moscow',
    bio: [
      {date: '1913 - 1918', text: 'He studied at the MUZHVZ (his father was rector of a nearby temple), then until 1924 in VKhUTEMAS.'},
      {date: '1924', text: 'He worked in architectural and design organizations of Moscow and at the same time taught (1934-1941, from 1948 — Professor) in MARHI .'},
      {date: '1941 - 1944', text: 'Senior researcher of the Academy of architecture of the USSR'},
      {date: '1944 - 1948', text: 'Head of architectural design workshops of the Committee on architecture of the USSR.'},
    ],
    project: [
      {date: '1930', text: 'Author of the project planning and development of Astrakhan '},
      {date: '1923', text: 'Machine building pavilion and audience at the all-Russian agricultural and handicraft industrial exhibition in Moscow'},
      {date: '1936', text: 'A number of houses on Prospekt Mira in Moscow \'Houses with an arch\' in Yaroslavl, including the house on red square'},
      {date: '1945—1947', text: 'Administrative building — KGB of Belarus'},
      {date: '1950', text: 'The state Bank of the USSR'},
      {date: '1946—1954', text: 'Houses and bridge over the river Svisloch, Sports complex \'Dynamo\''},
    ],
    video: {
      id: 'mrfadR51D0I'
    },
    mapData: {
      center: [53.898869, 27.554819],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/7/71/Minsk_skaryny_ave_02.jpg',
        width: 4,
        height: 3,
        title: 'The KGB building in Minsk',
        text: 'The KGB building in Minsk'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/3/32/NBRB.JPG',
        width: 2,
        height: 2,
        title: 'The building of the national Bank of Belarus',
        text: 'The building of the national Bank of Belarus'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/c/c5/Захар%27еўскі_мост.jpg',
        width: 2,
        height: 2,
        title: 'Bridge over Svisloch',
        text: 'Bridge over Svisloch'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/Buildings_in_Yaroslavl_009.jpg',
        width: 4,
        height: 3,
        title: 'Building with an archway in red square',
        text: 'Building with an archway in red square'
      },
    ],
  },

  {
    id: 'A4',
    url: 'leonid-mendelevich',
    name: 'Leonid Mendelevich Levin',
    bornDate: '07/25/1936',
    born: 'July 25, 1936',
    deceased: 'March 1, 2014',
    description: 'The distinguished architect of the Republic of Belarus, winner of the Lenin Prize and the Lenin Komsomol Prize, winner of the Volgograd Komsomol Prize, twice winner of the State Prize of the Republic of Belarus, laureate of many prestigious competitions and architectural works reviews, Chairman of the Union of Belarusian Jewish public associations and communities since 1991.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Levin_Leonid_Mendele.jpg/800px-Levin_Leonid_Mendele.jpg',
    placeOfResidence: 'Минск',
    placeOfBirth: 'Минск',
    bio: [
      {date: '1954 - 1960', text: 'Study at the Belarusian Polytechnic Institute.'},
      {date: '1960', text: 'Work at the Minskproject Institute (from architect to the head of the Minsk Construction Center Workshop).'},
      {date: '1960 - 1967', text: 'Participation in the creation of the 50th anniversary of Soviet power park.'},
      {date: '1968', text: 'Participation in the creation of the VDNH BSSR exhibition pavilion in Minsk.'},
      {date: '1970', text: 'As a part of the group of authors, was awarded the Lenin Prize for the Khatyn Memorial Complex.'},
      {date: '1997', text: 'Director of the own creative workshop «Creative workshop of the architect L. Levin».'},
      {date: 'March 4, 2014', text: 'Was buried at the Central Avenue of the Eastern Cemetery in Minsk.'},
    ],
    project: [
      {date: '1969', text: 'Memorial complex «Khatyn»'},
      {date: '1972', text: 'Yanka Kupala monument'},
      {date: '1972', text: 'Yakub Kolas monument'},
      {date: '1979', text: 'Shunevka (memorial complex \'Curse to Fascism\')'},
      {date: '1980 - 1986', text: 'Reconstruction of the historical part of Minsk - «The Troitsky suburb»'},
      {date: '1984', text: 'Authorship of Minsk metro station «Lenin Square»'},
      {date: '1990', text: 'Authorship of Minsk metro station «Nemiga»'},
      {date: '2004', text: 'Memorial complex to the murdered Jews in Gorodeya'},
    ],
    video: {
      id: 'P2-yBJvcJUo'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/0/01/Khatyn_Memorial%2C_Belarus.jpg',
        width: 4,
        height: 3,
        title: 'Khatyn memorial complex',
        text: 'Khatyn memorial complex'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Belarus-Minsk-Memorial_Pit-2.jpg',
        width: 2,
        height: 2,
        title: 'Memorial to the victims of Hitler\'s genocide \'Pit\'',
        text: 'Memorial to the victims of Hitler\'s genocide \'Pit\''
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/ru/f/ff/Yanka-kupala-minsk.jpg',
        width: 2,
        height: 2,
        title: 'Monument to Janka Kupala',
        text: 'Monument to Janka Kupala'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/97/The_Minsk_Thinker_-_panoramio.jpg',
        width: 4,
        height: 3,
        title: 'Monument to Yakub Kolas',
        text: 'Monument to Yakub Kolas'
      },
    ],
  },

  {
    id: 'A5',
    url: 'yesman',
    name: 'Esman Igor Ivanovich',
    bornDate: '01/05/1932',
    born: '1 may 1932',
    deceased: 'Present',
    description: 'Igor Ivanovich Yesman, an architect, designer and inventor, dreamed of building a grandiose research and training center at the entrance to Minsk: the Minsk Institute of Architecture and Construction (MAIS) and the ultramodern Belarusian State University.',
    image: 'https://s16.stc.all.kpcdn.net/share/i/12/2109386/inx960x640.jpg',
    placeOfResidence: 'Minsk',
    placeOfBirth: 'Minsk',
    bio: [
      {date: '1948', text: 'Igor Yesman chose the profession of an architect and became a student of the Minsk Architectural and Construction College.'},
      {date: '1959', text: 'He graduated from the architectural department of the Belarusian Polytechnic Institute (now BNTU).'},
      {date: '1960 - 1995', text: 'He works at the institute \'Minskproekt\', having gone from a simple architect to a senior, and then the chief architect of projects and the head of a workshop.'},
      {date: '1995 - p.t.', text: 'Igor Ivanovich is in free creative flight of thought, continuing to surprise and delight those around him. Makes a transforming set for the play \'Angel over the Roof.\' He is fond of artistic stone and bone carving, develops design of stamps, produces miniature books, studies and manufactures antiquities in a miniature version.'},
    ],
    project: [
      {date: '1958', text: 'Entrance platform in the bread shop on the street Romanov Sloboda.'},
      {date: '1961 - 1963', text: 'Minsk Institute of Foreign Languages (now MSLU) on the street. Zakharov.'},
      {date: '1964', text: 'Institute of Technical Aesthetics on the street. Zhilunovich, production building, exhibition hall.'},
      {date: '1965', text: 'Experimental kindergarten-nursery for 320 places in the micro-district \'Serebryanka-6\' and re-used kindergartens.'},
      {date: '1966', text: 'Individual residential houses in Partizansky Ave. and Romanovskaya Sloboda. Institute of National Economy, Assembly and Sports Halls.'},
      {date: '1967', text: 'First place in the open competition for the development of a holiday emblem, a commemorative medal and a series of badges for the 900th anniversary of the city of Minsk.'},
      {date: '1968', text: 'The complex of administrative buildings with a meeting room on the street. Nekrasov.'},
      {date: '1972', text: 'Complex of hostels with service blocks of the Institute of National Economy on Bicyclic Lane.'},
      {date: '1970 - 1983', text: 'Faculty of Architecture and Civil Engineering of the Belarusian National Technical University, Independence Avenue 150, Minsk'},
      {date: '1980', text: 'The complex of buildings of the hotel \'Orbita\' on Pushkin Avenue'},
      {date: '1990', text: 'Metro station \'Pushkinskaya\''},
    ],
    video: {
      id: 'jL_MPmr0U-U'
    },
    mapData: {
      center: [53.937772, 27.669495],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'http://www.minsk.nemiga.info/silicon-valley/bntu-8.jpg',
        width: 4,
        height: 3,
        title: 'Faculty of Architecture and Civil Engineering of BNTU',
        text: 'Faculty of Architecture and Civil Engineering of BNTU'
      },
      {
        num: 2,
        src: 'https://www.belarusinfo.by/ru/images/stories/photo_gallery/20k/15655/%D0%9C%D0%93%D0%9B%D0%A3.jpg',
        width: 4,
        height: 2,
        title: 'Minsk State Linguistic University',
        text: 'Minsk State Linguistic University'
      },
      {
        num: 3,
        src: 'http://bseu.by/images/hostels/5.jpg',
        width: 2,
        height: 2,
        title: 'Hostels of the Belarusian State Economic University',
        text: 'Hostels of the Belarusian State Economic University'
      },
      {
        num: 4,
        src: 'https://t-ec.bstatic.com/images/hotel/max1024x768/321/32147559.jpg',
        width: 4,
        height: 3,
        title: 'Hotel Orbita, Minsk',
        text: 'Hotel Orbita, Minsk'
      },
    ],
  },

  {
    id: 'A6',
    url: 'sacco',
    name: 'Giuseppe de Sacco',
    bornDate: '12/11/1735',
    born: '1735',
    deceased: '1798',
    description: 'One of the greatest architects of developed Baroque and Classicism, who worked on the territory of modern Belarus in the XVIII century. The court architect of the king Stanislaw August Poniatowski. Also worked in other regions of the The Polish–Lithuanian Commonwealth. The ensembles of palace and park residences stand out in his works.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/%D0%9F%D0%BE%D0%BC%D0%BD%D1%96%D0%BA_%D0%A1%D0%B0%D0%BA%D0%B0.JPG/375px-%D0%9F%D0%BE%D0%BC%D0%BD%D1%96%D0%BA_%D0%A1%D0%B0%D0%BA%D0%B0.JPG',
    placeOfResidence: 'Гродно',
    placeOfBirth: 'Верона',
    bio: [
      {date: '1768', text: 'Was invited to Warsaw, where he studied the Castrum Doloris of Queen Marie Leszczyńska and the rebuilding project of the St.Jan church.'},
      {date: '1771', text: 'Became an architect of the Skarbovaya commission of The Grand Duchy of Lithuania. Was recommended to the Grodno headman Anthony Tizengauz and was hired as a royal architect, with a fixed salary of 600 zlotys. In The Polish–Lithuanian Commonwealth de Sacco receives a number of military titles of The Grand Duchy of Lithuania.'},
      {date: '1771 - 1780', text: 'Completed a number of orders from local magnates, having designed several well-known palace and park ensembles and city residences, in particular: the Volovichi magnates Palace in Svyatsk, the Khreptovichi Palace in Shchorsy, the Tizengauz Palaces in Postavy and Vilnius (presumably).'}
    ],
    project: [
      {date: 'XVIII century', text: 'The Palace in Tsyonzheni'},
      {date: 'XVIII century', text: 'The Khreptovichi Palace in Shchorsy'},
      {date: 'XVIII century', text: 'The Tizengauz theater'},
      {date: 'XVIII century', text: 'The Palace in Svyatsk'},
      {date: 'XVIII century', text: 'The Tizengauz Palace'},
      {date: 'XVIII century', text: 'The Palace in Mosar'},
    ],
    video: {
      id: 'TkaLjjNj8Ls'
    },
    mapData: {
      center: [53.684727, 23.834317],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/6/6c/Ci%C4%85%C5%BCe%C5%84_-_pa%C5%82ac_biskup%C3%B3w_pozna%C5%84skich_03.jpg',
        width: 4,
        height: 3,
        title: 'The Palace in Tsyonzheni',
        text: 'The Palace in Tsyonzheni'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/%D0%A1%D1%82%D0%B0%D0%BD%D0%B8%D1%81%D0%BB%D0%B0%D0%B2%D0%BE%D0%B2%D0%BE.JPG/1920px-%D0%A1%D1%82%D0%B0%D0%BD%D0%B8%D1%81%D0%BB%D0%B0%D0%B2%D0%BE%D0%B2%D0%BE.JPG',
        width: 2,
        height: 2,
        title: 'Stanislavovo (manor house)',
        text: 'Stanislavovo (manor house)'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/%D0%90%D0%BD%D1%81%D0%B0%D0%BC%D0%B1%D0%BB%D1%8C_%D0%BF%D0%BB%D0%BE%D1%89%D0%B0%D0%B4%D0%B8_%D0%A2%D0%B8%D0%B7%D0%B5%D0%BD%D0%B3%D0%B0%D1%83%D0%B7%D0%B0.JPG/1280px-%D0%90%D0%BD%D1%81%D0%B0%D0%BC%D0%B1%D0%BB%D1%8C_%D0%BF%D0%BB%D0%BE%D1%89%D0%B0%D0%B4%D0%B8_%D0%A2%D0%B8%D0%B7%D0%B5%D0%BD%D0%B3%D0%B0%D1%83%D0%B7%D0%B0.JPG',
        width: 2,
        height: 2,
        title: 'The Tizengauz square',
        text: 'The Tizengauz square'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/97/%C5%9Aviacak._%D0%A1%D1%8C%D0%B2%D1%8F%D1%86%D0%B0%D0%BA_%282006%29.jpg',
        width: 4,
        height: 3,
        title: 'The Palace in Svyatsk',
        text: 'The Palace in Svyatsk'
      },
      {
        num: 5,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/%D0%A2%D0%B5%D0%B0%D1%82%D1%80_%D0%BA%D1%83%D0%BA%D0%BE%D0%BB_%D0%B2_%D0%93%D1%80%D0%BE%D0%B4%D0%BD%D0%BE.JPG/1280px-%D0%A2%D0%B5%D0%B0%D1%82%D1%80_%D0%BA%D1%83%D0%BA%D0%BE%D0%BB_%D0%B2_%D0%93%D1%80%D0%BE%D0%B4%D0%BD%D0%BE.JPG',
        width: 4,
        height: 3,
        title: 'The Tizengauz theater',
        text: 'The Tizengauz theater'
      },
    ],
  },
];

const developers = [
  {
    id: 'D1',
    name: 'Ivan Kononovich',
    github: 'https://github.com/ivankononovich',
    image: 'https://avatars0.githubusercontent.com/u/41195901?s=400&v=4',
    contribution: '➤Created the basic structure of the project.\n ➤Implemented the transition between pages using react router.\n ➤Implemented a website translation into three languages (the whole team wrote the text).',
  },
  {
    id: 'D2',
    name: 'Evgeni Matveyonok',
    github: 'https://github.com/ins21',
    image: 'https://ins21.github.io/rsschool-2019Q1-cv/assets/images/1.png',
    contribution: '➤Created the Architect page component and its layout using Material UI. \n ➤Added the TimeLine component and the Map component. \n ➤Translated the pages of two architects into Belarusian and English.',
  },
  {
    id: 'D3',
    name: 'Katerina Zhadko',
    github: 'https://github.com/cathzetjo',
    image: 'https://avatars3.githubusercontent.com/u/44948376?s=460&v=4',
    contribution: '➤Component Developers page. Plus Layout and styles according Material UI for Developers page.\n' +
      ' ➤Component PhotoGallery - gallery on architects pages.\n' +
      ' ➤Content on the page of architect Usova Lubov with translation.\n' +
      ' ➤Content and picture on Home page.',
  },
  {
    id: 'D4',
    name: 'Arthur Rubchenko',
    github: 'https://github.com/Arthur199212',
    image: 'https://avatars0.githubusercontent.com/u/46008463?s=460&v=4',
    contribution: '➤Created the menu bar and the architect of the day components.\n ➤The architect of the day is selected by birth date.\n ➤The menu is responsive and was implemented using the Material-UI.',
  },
  {
    id: 'D5',
    name: 'Dmitriy Porhomenko',
    github: 'https://github.com/DmitriyParhomenko',
    image: 'https://avatars0.githubusercontent.com/u/37816988?s=460&v=4',
    contribution: '➤Created two components which use Material UI: table of projects on the website of the architect and the modal window displaying a YouTube video.\n ➤Both components are adaptive. For a table, a horizontal scroll appears in the adaptive.\n ➤Corrected style for the entire site.',
  },
  {
    id: 'D6',
    name: 'Pavel Khomich',
    github: 'https://github.com/pashax0',
    image: 'https://avatars3.githubusercontent.com/u/17899361?s=460&v=4',
    contribution: '➤Created component footer showing information about the developers.\n ➤The implementation of the search component on the page of architects with showing of results. Components are made using Material UI.\n ➤Basic SEO optimization.',
  }
];

const portalDescription = {
  title: 'Architects of Belarus',
  description: '<p>The country\'s architecture it is some kind of image of the state, it can reveal the historical heritage, talk about tastes, preferences and living standards of the state.</p>' +
    '<p>The architecture of Belarus is a true testament to its rich history. Monuments of history, architectural structures are connected with medieval, East European and Russian art. They absorbed national and European trends in the development of architecture. Castles of Belarus are unique masterpieces.</p>' +
    '<p>Many buildings in the country are made in the Byzantine-Balkan style, which makes them more pronounced against the background of modern buildings. Baroque monumental monuments, palaces in Grodno, Mogilev are distinguished by sophistication and sophistication. The palace ensembles in Gomel belong to the monuments of classicism.</p>' +
    '<p>The architecture of Belarus is associated with its historical events, interweaving of artistic styles. The variety of styles makes the country even more vibrant and picturesque.</p>' +
    '<p>Belarus has a huge historical heritage. And today, new masterpieces of architecture are being created and restored.</p>' +
    '<p>This portal is about people who created the history of Belorussian architecture with their own hands.</p>',
  architectOfTheDay: 'Architect Of The Day',
  img: 'https://i.ibb.co/Brsc9Sw/main-Picture.png',
};

const architectPageLanguage = {
  years: 'Years of life',
  bio: 'Biography',
  projects: 'Projects',
  projectHeader: {
    columnOne: 'Projects',
    columnTwo: 'Creation date'
  },
  video: 'Video',
  videoButton: 'View',
  map: 'Place of major activity',
  gallery: 'Photo Gallery',
};

export default {
  SEO: {
    lang: 'en',
    title: 'Architects of Belarus',
    description: 'Architects of Belarus: a biography and their work. Who built the building, in which year, whose project'
  },
  architects,
  developers,
  portalDescription,
  architectPageLanguage,
  architectsNav: 'Architects',
  developersList: 'Developers',
  homePageLink: 'Home',
  searchLabel: 'Name or place of birth',
  architectOfTheDayButton: 'Learn more',
}
